import { useDispatch } from 'react-redux';

/**
 * A pre-typed `useDispatch` in order to handle thunks (or other middleware)
 * @see https://redux.js.org/usage/usage-with-typescript/#define-typed-hooks
 */
export const useAppDispatch = (): Redux.Dispatch =>
  useDispatch<Redux.Dispatch>();
